import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Navigation
    home: 'Home',
    about: 'About',
    divisions: 'Divisions',
    services: 'Services',
    projects: 'Projects',
    news: 'News',
    certificates: 'Certificates',
    pepApp: 'ALMAD PEP App',
    contact: 'Contact',
    workWithUs: 'Work With Us',
    
    // Hero
    heroTitle: 'Together, we build a sustainable future.',
    heroSubtitle: 'A Saudi-owned EPC contractor delivering integrated solutions in construction, electromechanical works, engineering, and sustainability — aligned with the Kingdom\'s Vision 2030.',
    exploreDivisions: 'Explore Divisions',
    downloadProfile: 'Download Profile',
    
    // About
    aboutTitle: 'About ALMAD Contracting',
    aboutSubtitle: 'Proudly Saudi. Performance-driven. Future-focused.',
    aboutText1: 'ALMAD Contracting is dedicated to delivering excellence through structured divisions and specialized teams ensuring focused execution and lasting value.',
    aboutText2: 'Our comprehensive EPC model integrates engineering, procurement, and construction for complete, efficient, and sustainable project delivery.',
    aboutText3: 'We contribute to Vision 2030 by building infrastructure, industries, and sustainable developments across the Kingdom.',
    coreStrengths: 'Core Strengths',
    strength1: 'Structured Excellence',
    strength2: 'Integrated EPC Capability',
    strength3: 'Sustainability Commitment',
    strength4: 'Client Partnership',
    
    // Mission & Vision
    missionVisionTitle: 'Mission & Vision',
    mission: 'Mission',
    missionText: 'To provide innovative comprehensive solutions that enhance the built environment while upholding the highest standards of quality and safety.',
    vision: 'Vision',
    visionText: 'To become the leading provider of innovative comprehensive solutions in the region, recognized for excellence, sustainability, and client satisfaction.',
    
    // Divisions
    divisionsTitle: 'Business Divisions',
    divisionsSubtitle: 'Comprehensive capabilities across the EPC value chain.',
    construction: 'Construction',
    constructionText: 'Civil, structural, and finishing works executed with precision and safety.',
    mep: 'Electromechanical (MEP)',
    mepText: 'Full mechanical, electrical, and low current systems managed end-to-end.',
    engineering: 'Engineering & Design',
    engineeringText: 'Concept, detailed, and BIM documentation to meet the highest technical standards.',
    procurement: 'Procurement & Logistics',
    procurementText: 'Efficient, transparent sourcing and supplier coordination for all project components.',
    projectMgmt: 'Project Management',
    projectMgmtText: 'Complete planning, scheduling, cost control, and HSE compliance.',
    operations: 'Operations & Maintenance',
    operationsText: 'Sustaining assets through long-term O&M contracts.',
    sustainable: 'Sustainable Developments',
    sustainableText: 'Delivering renewable, clean energy, and decarbonization solutions.',
    
    // Services
    servicesTitle: 'EPC Services',
    servicesSubtitle: 'End-to-end contracting and engineering services built for performance, safety, and reliability.',
    coreEPC: 'Core EPC',
    supportServices: 'Support Services',
    sustainability: 'Sustainability',
    
    // Projects
    projectsTitle: 'Projects',
    projectsSubtitle: 'Showcasing the project types we can carry out',
    buildingsInfra: 'Buildings & Infrastructure',
    industrialEnergy: 'Industrial & Energy',
    sustainableDev: 'Sustainable Developments',
    
    // News
    newsTitle: 'News & Updates',
    newsSubtitle: 'Latest from ALMAD Contracting',
    readMore: 'Read More',
    
    // PEP App
    pepTitle: 'ALMAD PEP App',
    pepText: 'A secure internal platform for ALMAD employees to manage projects, HR, and site operations.',
    openPepApp: 'Open ALMAD PEP App',
    requestAccess: 'Request Access',
    
    // Certificates
    certificatesTitle: 'Certifications & Compliance',
    certificatesSubtitle: 'Quality, safety, and operational excellence.',
    
    // Contact
    contactTitle: 'Contact ALMAD',
    contactSubtitle: 'Let\'s discuss your project or partnership opportunity.',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    viewMap: 'View on Map',
    
    // Footer
    footerTagline: 'Where Vision Becomes Reality.',
    quickLinks: 'Quick Links',
    followUs: 'Follow Us',
    allRightsReserved: '© 2025 ALMAD Contracting. All rights reserved.',
  },
  ar: {
    // Navigation
    home: 'الرئيسية',
    about: 'من نحن',
    divisions: 'الأقسام',
    services: 'الخدمات',
    projects: 'المشاريع',
    news: 'الأخبار',
    certificates: 'الشهادات',
    pepApp: 'تطبيق ALMAD PEP',
    contact: 'اتصل بنا',
    workWithUs: 'العمل معنا',
    
    // Hero
    heroTitle: 'معاً، نبني مستقبلاً مستداماً.',
    heroSubtitle: 'مقاول EPC سعودي يقدم حلولاً متكاملة في البناء والأعمال الكهروميكانيكية والهندسة والاستدامة - متماشياً مع رؤية المملكة 2030.',
    exploreDivisions: 'استكشف الأقسام',
    downloadProfile: 'تحميل الملف التعريفي',
    
    // About
    aboutTitle: 'عن شركة المعد للمقاولات',
    aboutSubtitle: 'فخورون بسعوديتنا. موجهون بالأداء. مركزون على المستقبل.',
    aboutText1: 'تلتزم شركة المعد للمقاولات بتقديم التميز من خلال أقسام منظمة وفرق متخصصة تضمن التنفيذ المركز والقيمة الدائمة.',
    aboutText2: 'يدمج نموذج EPC الشامل لدينا الهندسة والمشتريات والبناء لتقديم مشاريع كاملة وفعالة ومستدامة.',
    aboutText3: 'نساهم في رؤية 2030 من خلال بناء البنية التحتية والصناعات والتطورات المستدامة في جميع أنحاء المملكة.',
    coreStrengths: 'نقاط القوة الأساسية',
    strength1: 'التميز المنظم',
    strength2: 'قدرة EPC المتكاملة',
    strength3: 'الالتزام بالاستدامة',
    strength4: 'الشراكة مع العملاء',
    
    // Mission & Vision
    missionVisionTitle: 'المهمة والرؤية',
    mission: 'المهمة',
    missionText: 'تقديم حلول شاملة مبتكرة تعزز البيئة المبنية مع الحفاظ على أعلى معايير الجودة والسلامة.',
    vision: 'الرؤية',
    visionText: 'أن نصبح المزود الرائد للحلول الشاملة المبتكرة في المنطقة، معترف بنا للتميز والاستدامة ورضا العملاء.',
    
    // Divisions
    divisionsTitle: 'أقسام الأعمال',
    divisionsSubtitle: 'قدرات شاملة عبر سلسلة قيمة EPC.',
    construction: 'البناء',
    constructionText: 'أعمال مدنية وإنشائية وتشطيب تُنفذ بدقة وأمان.',
    mep: 'الكهروميكانيكية (MEP)',
    mepText: 'أنظمة ميكانيكية وكهربائية وتيار منخفض كاملة تُدار من البداية إلى النهاية.',
    engineering: 'الهندسة والتصميم',
    engineeringText: 'مفهوم مفصل ووثائق BIM لتلبية أعلى المعايير الفنية.',
    procurement: 'المشتريات واللوجستيات',
    procurementText: 'توريد فعال وشفاف وتنسيق الموردين لجميع مكونات المشروع.',
    projectMgmt: 'إدارة المشاريع',
    projectMgmtText: 'تخطيط كامل وجدولة والتحكم في التكاليف والامتثال للسلامة والصحة والبيئة.',
    operations: 'العمليات والصيانة',
    operationsText: 'الحفاظ على الأصول من خلال عقود O&M طويلة الأجل.',
    sustainable: 'التطورات المستدامة',
    sustainableText: 'تقديم حلول الطاقة المتجددة والنظيفة وإزالة الكربون.',
    
    // Services
    servicesTitle: 'خدمات EPC',
    servicesSubtitle: 'خدمات المقاولات والهندسة الشاملة المبنية على الأداء والسلامة والموثوقية.',
    coreEPC: 'EPC الأساسية',
    supportServices: 'خدمات الدعم',
    sustainability: 'الاستدامة',
    
    // Projects
    projectsTitle: 'المشاريع',
    projectsSubtitle: 'عرض أنواع المشاريع التي يمكننا تنفيذها',
    buildingsInfra: 'المباني والبنية التحتية',
    industrialEnergy: 'الصناعة والطاقة',
    sustainableDev: 'التطورات المستدامة',
    
    // News
    newsTitle: 'الأخبار والتحديثات',
    newsSubtitle: 'آخر الأخبار من شركة المعد للمقاولات',
    readMore: 'اقرأ المزيد',
    
    // PEP App
    pepTitle: 'تطبيق ALMAD PEP',
    pepText: 'منصة داخلية آمنة لموظفي ALMAD لإدارة المشاريع والموارد البشرية وعمليات الموقع.',
    openPepApp: 'فتح تطبيق ALMAD PEP',
    requestAccess: 'طلب الوصول',
    
    // Certificates
    certificatesTitle: 'الشهادات والامتثال',
    certificatesSubtitle: 'الجودة والسلامة والتميز التشغيلي.',
    
    // Contact
    contactTitle: 'اتصل بـ ALMAD',
    contactSubtitle: 'دعنا نناقش مشروعك أو فرصة الشراكة.',
    address: 'العنوان',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    viewMap: 'عرض على الخريطة',
    
    // Footer
    footerTagline: 'حيث تصبح الرؤية حقيقة.',
    quickLinks: 'روابط سريعة',
    followUs: 'تابعنا',
    allRightsReserved: '© 2025 شركة المعد للمقاولات. جميع الحقوق محفوظة.',
  }
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [direction, setDirection] = useState('ltr');

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = direction;
  }, [language, direction]);

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'ar' : 'en';
    setLanguage(newLang);
    setDirection(newLang === 'ar' ? 'rtl' : 'ltr');
  };

  const t = (key) => translations[language][key] || key;

  return (
    <LanguageContext.Provider value={{ language, direction, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};